module.exports = __webpack_public_path__ + "static/blog_business_plan-dec4fddcce267684ba0a922ca1848fe1.jpg";